/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_4_VInputs */

const en_cp_fact_4_v = /** @type {(inputs: Cp_Fact_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 tasks without evidence`)
};

const id_cp_fact_4_v = /** @type {(inputs: Cp_Fact_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 task tanpa bukti`)
};

/**
* | output |
* | --- |
* | "0 tasks without evidence" |
*
* @param {Cp_Fact_4_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_4_v = /** @type {((inputs?: Cp_Fact_4_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_4_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_4_v(inputs)
	return en_cp_fact_4_v(inputs)
});